import e from "./SchemaRailPanel.vue_vue_type_script_setup_true_lang.js";
//#region src/schema/SchemaRailPanel.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaRailPanel.vue.js.map